// extracted by mini-css-extract-plugin
export default {"charsCounter":"CharsCounter_charsCounter__X4oC5","counter":"CharsCounter_counter__6IMp9"};